module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "data-backdrop": "false"
    },
    on: {
      "click": _vm.clickOutside
    }
  }, [_c('div', {
    staticClass: "modal-wrapper mid-spacing",
    on: {
      "click": _vm.clickInside
    }
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    staticClass: "modal-inner",
    class: _vm.computedModalInnerClass
  }, [_c('div', {
    staticClass: "modal-component",
    class: _vm.computedModalComponentClass
  }, [_c('div', {
    staticClass: "modal-headers"
  }, [(_vm.type === 'warning') ? _c('img', {
    attrs: {
      "src": _vm.warningSrc
    }
  }) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.subtitle) ? _c('div', {
    staticClass: "modal-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.type == 'create' && _vm.cancelText != null) ? _c('a', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.cancelText)))]) : _vm._e(), _vm._v(" "), (_vm.saveText) ? _c('button', {
    staticClass: "btn btn-flat",
    class: _vm.computedModalFooterButtonClass.concat(_vm.type == 'warning' ? 'warning' : ''),
    attrs: {
      "disabled": _vm.saveDisabled
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.saveText)))]) : _vm._e(), _vm._v(" "), (_vm.type == 'warning' && _vm.showCancelForWarning && _vm.cancelText != null) ? _c('button', {
    staticClass: "btn btn-flat",
    class: _vm.computedModalFooterButtonClass,
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.cancelText)))]) : _vm._e()]) : _vm._e()])], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a001b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Layout/NewModal.vue
// module id = 1923
// module chunks = 0